// extracted by mini-css-extract-plugin
module.exports = {"loading":"a10a3f92e9--loading--yf_v7","overlap":"a10a3f92e9--overlap--kORka"};